import type { ServiceStatusCheck } from '../model/types';


export type Health = {
    state: 'unknown' | 'ON (stable)' | 'degraded' | 'down';
    tone: 'secondary' | 'success' | 'warning' | 'destructive';
}

export function getHealth (latest: ServiceStatusCheck | null, passed: number, total: number): Health {
    if (!latest || total === 0 || latest.clientError) return {
        state: 'unknown',
        tone : 'secondary',
    };

    if (!latest.ok) return {
        state: 'down',
        tone : 'destructive',
    };

    if (passed < total) return {
        state: 'degraded',
        tone : 'warning',
    };

    return {
        state: 'ON (stable)',
        tone : 'success',
    };
}
